import { Component, OnInit, Inject, OnDestroy, AfterViewInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatInput, MatSelect, MatDatepickerInputEvent, MAT_DATE_FORMATS } from '@angular/material';
import { UserService } from 'src/app/core/services/user.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CommonService } from 'src/app/core/services/common.service';
import { NgForm } from '@angular/forms';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { AutocompleteComponent } from 'src/app/shared/components/autocomplete/autocomplete.component';
import { DepartmentService } from 'src/app/core/services/department.service';
import { Common } from 'src/app/core/constants/common';
import { MY_FORMATS } from 'src/app/app.component';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class UpdateUserComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  user = {
    id: null,
    tenantId: null,
    userName: '',
    fullName: '',
    userType: null,
    enterpriseId: '',
    departmentId: null,
    phone: '',
    email: '',
    description: '',
    isActive: true,
    certificateId: null,
    certificateNo: '',
    userPosition: '',
    nationality: '',
    livingAddress: '',
    address: '',
    idIssuePlace: '',
    birthday: null,
    idIssueDate: null,
  };
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  certificateSelected: number = null;

  enterprises: {
    id: null,
    name: '',
    enterpriseType: null,
    tenantId: null,
    foreignName: '',
    parentId: null,
    abbreviation: '',
    taxCode: '',
    licenceDate: null,
    activeDate: null,
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    expiryDate: null,
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: null,
    representativeIssuedOn: '',
    status: true,
    addresses: [
      {
        cityId: null,
        districtId: null,
        wardId: null,
        enterpriseId: null,
        address: ''
      }
    ]
  }[];
  enterpriseAccount = '';
  listDepartment = [];
  listDepartmentFilter = [];
  listCertificate = [
    {
      name: 'CCCD',
      id: 30002
    },
    {
      name: 'Hộ chiếu',
      id: 30001
    },
    {
      name: 'CMTND',
      id: 30000
    }
  ];
  listCertificateFilter = [];
  id: any;
  checkFocus = true;
  // List all parent branches
  parentBranches: { id: string, name: '' }[];
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };
  @ViewChild(AutocompleteComponent, { read: AutocompleteComponent, static: true }) autocompleteComponent;
  @ViewChild('userTypeSelect', { static: false }) userTypeSelect: MatSelect;
  @HostListener('submit')
  onFormSubmit() {
     const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }
  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  checkEscKey = false;
  isActive = false;
  phonePattern = Common.PHONE_PATTERN2;
  phoneMaxlength = Common.MAX_LENGTH_PHONE;
  @ViewChild('focusInput', { static: false }) focusInput: MatInput;
  oldUserName;
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.onNoClick();
    }
  }

  /**
   * Check first load data
   */
  firstLoaded = true;

  // Check if current user is a regular user (userType=2) — disable user_type field
  currentUserType: number = Number(localStorage.getItem('userType'));
  isUserTypeDisabled: boolean = this.currentUserType === 2;

  constructor(
    private el: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    public dialogRef: MatDialogRef<UpdateUserComponent>,
    public notificationService: NotificationService,
    public dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private departmentService: DepartmentService
  ) {
    super(commonService, message);
    this.user.id = data.userId;
    this.id = data.userId;
    this.enterprises = [];
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onNoClick();
    });
  }

  ngOnInit() {
    // console.log(this.data);
    this.getUserById(this.user.id);
    this.getRepresentativeCertificateType();
  }
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        const result = rs.data;
        this.listCertificate = result;
        this.listCertificateFilter = this.listCertificate;
      }
    });
  }
  addEvent(event: MatDatepickerInputEvent<Date>) {
    // this.change = true;
  }

  ngAfterViewInit() {
    // this.user.departmentId = this.data.departmentId;
    setTimeout(_ => this.focusInput.focused = true);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty || this.ngForm.touched) {
        this.isFormChanging = true;
      }
    });
  }
  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }

  onclickButtonUpdate() {
    let regexpNumber = new RegExp(this.phonePattern);
    if (!regexpNumber.test(this.user.phone.trim())) {
      this.toastr.error(this.message.getMessage('validation.phone_number_10_or_11_invalid_format'));
      return;
    }
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        //them ten nguoi dung
        data: this.commonService.format(this.message.getMessage('messages.confirm_update_users'), this.oldUserName)
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.userService.updateUserEnterprise(this.user.id,
          {
            ...this.user,
            userType: Number(this.user.userType),
            certificateId : this.certificateSelected
          },
          () => {
            this.toastr.success(this.message.getMessage('messages.update_success'));
            this.dialogRef.close();
          },
          () => {
            this.getUserById(this.user.id);
          },
          this.onUpdateUserError.bind(this));
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  private onUpdateUserError(rs: any) {
    if (!rs.success) {
      this.notificationService.notify(rs.message);
      // this.toastr.error(rs.message);
      // this.user.departmentId = null;
      // this.getDepartments();
    } 
  }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (this.selectedBranch == null || this.selectedBranch == undefined || this.selectedBranch.name.trim().length === 0) {
      this.user.enterpriseId = '';
      this.enterpriseAccount = '';
    } else if (this.selectedBranch != null && this.selectedBranch != undefined || this.selectedBranch.name.trim().length !== 0) {
      this.user.enterpriseId = this.selectedBranch.id;
      if (this.firstLoaded) {
        this.firstLoaded = false;
      } else {
        this.ngForm.control.markAsDirty();
      }
    }
  }

  /**
   * Get parent branches for creating branch
   */
  getParentBranches() {
    this.userService.getAllChild(
      localStorage.getItem('enterpriseId')
    ).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.parentBranches = rs.data;

      this.selectedBranch = this.parentBranches.find(x => {
        return x.id === this.user.enterpriseId;
      });
      // this.autocompleteComponent.formControl.setValue({id: this.selectedBranch.id, name: this.selectedBranch.name});
    });
  }

  /**
   * Get user by id
   * @param userId: any
   */
  getUserById(userId: any) {
    this.userService.getUser(userId)
      .subscribe(rs => {
        this.oldUserName = rs.data.fullName;
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.user = {
          ...this.user,
          ...rs.data,
        };
        if (this.user.idIssueDate) {
          this.user.idIssueDate = new Date(this.user.idIssueDate);
        }
        if (this.user.birthday) {
          this.user.birthday = new Date(this.user.birthday);
        }
        this.certificateSelected = rs.data.certificateId;
        this.isActive = this.user.isActive;
        // console.log('user:', this.user)
       this.getDepartments(this.user.enterpriseId);

        this.getParentBranches();
      });
  }

  /**
   * Close updating user dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  getDepartments(enterpriseId) {
    this.departmentService.getDepartmentByUserEnterprise(enterpriseId).subscribe(res => {
      if (res.success) {
        this.listDepartment = res.data;
        // console.log('data', res.data);
        // Kiểm tra nếu phòng ban hiện tại không còn hoạt động thì thêm vào list
        if (!this.isDepartmentActive() && this.user.departmentId !== null) {
          this.departmentService.getDepartmentInactiveById(this.user.departmentId).subscribe(res => {
            if (res.success) {
              // console.log('data', res.data);

              res.data[0].isDeleted = false;
              res.data[0].isActive = true;
              // console.log('list', this.listDepartment);
              this.listDepartment.unshift(res.data[0]);
            }
          });
        } else{
          // this.dialogRef.close();
        }
        this.listDepartmentFilter = this.listDepartment;
      }
    });
  }

  // Check phòng ban còn active hay không
  isDepartmentActive(): boolean {
    let isExist = false;
    this.listDepartment.forEach(item => {
      if (item.id === this.user.departmentId) {
        isExist = true;
      }
    });
    if (isExist) {
      return true;
    } else {
      return false;
    }
  }

  onInputChange(event: any) {
    const searchInput = event.target.value.toLowerCase();

    this.listDepartmentFilter = this.listDepartment.filter((item) => {
      const prov = item.name.toLowerCase();
      if (prov.includes(searchInput)) {
        item.isDeleted = false;
      } else {
        item.isDeleted = true;
      }
      return item;
    });
  }
  onInputCertificateChange(event: any) {
    const searchInput = event.target.value.trim().toLowerCase();

    this.listCertificateFilter = this.listCertificate.filter((item) => {
      const prov = item.name.toLowerCase();
      if (prov.includes(searchInput)) {
        return item;
      }
    });
  }
  clearCerNo() {
    this.user.certificateNo='';
  }
}
